// PLP Filter — Shopify Section Rendering API
// Gestisce: drawer form, sidebar checkboxes, sort popover, reset, paginazione, popstate

(function () {
	"use strict";

	function getCollectionSection() {
		return document.querySelector('[data-section-type="collection"]');
	}

	function getSectionId() {
		var section = getCollectionSection();
		return section
			? section.getAttribute("data-section-id")
			: "collection-template";
	}

	function getProductGrid() {
		return document.getElementById("bc-sf-filter-products");
	}

	function getPaginationContainer() {
		return document.getElementById("bc-sf-filter-bottom-pagination");
	}

	function getFilterForm() {
		return document.getElementById("CollectionFiltersForm");
	}

	function getCollectionMain() {
		return document.querySelector(".CollectionMain");
	}

	var productGrid = getProductGrid();

	if (!productGrid) return;

	// ── Nasconde i gruppi filtro con ≤ 1 opzione visibile ───────────────────
	// Un gruppo con una sola scelta non offre valore all'utente:
	// lo nascondiamo sia al caricamento iniziale che dopo ogni aggiornamento AJAX.
	function updateGroupVisibility() {
		document.querySelectorAll(".PlpFilter__Group").forEach(function (group) {
			var visibleOptions = group.querySelectorAll(
				".PlpFilter__Value:not(.hidden), .PlpFilter__Value--checkbox:not(.hidden)",
			);
			if (visibleOptions.length <= 1) {
				group.classList.add("hidden");
			} else {
				group.classList.remove("hidden");
			}
		});
	}

	// ── Fetch e aggiorna il grid via Section Rendering ──────────────────────
	function fetchSection(targetUrl) {
		var sectionId = getSectionId();
		var url = new URL(targetUrl, window.location.origin);
		url.searchParams.set("section_id", sectionId);

		fetch(url.toString(), { headers: { "X-Requested-With": "XMLHttpRequest" } })
			.then(function (res) {
				return res.text();
			})
			.then(function (html) {
				var parser = new DOMParser();
				var doc = parser.parseFromString(html, "text/html");
				var currentGrid = getProductGrid();
				var currentPagination = getPaginationContainer();
				var currentCollectionMain = getCollectionMain();
				var newGrid = doc.getElementById("bc-sf-filter-products");
				var newPagination = doc.getElementById(
					"bc-sf-filter-bottom-pagination",
				);
				var newCollectionMain = doc.querySelector(".CollectionMain");

				if (newGrid && currentGrid) {
					currentGrid.innerHTML = newGrid.innerHTML;
				} else if (newCollectionMain && currentCollectionMain) {
					// Fallback: replace the whole collection content when section_id returns a full section
					currentCollectionMain.innerHTML = newCollectionMain.innerHTML;
				} else {
					console.warn(
						"[PLP Filter] updated URL but no collection markup found in response",
						sectionId,
					);
				}

				if (newPagination && currentPagination) {
					currentPagination.innerHTML = newPagination.innerHTML;
				}

				[
					"#collection-filter-drawer .PlpFilter__ActiveSection",
					".PlpSidebar__Filters .PlpFilter__ActiveSection",
				].forEach(function (sel) {
					var cur = document.querySelector(sel);
					var nw = doc.querySelector(sel);
					if (cur && nw) cur.outerHTML = nw.outerHTML;
					else if (cur && !nw)
						cur.remove(); // nessun filtro attivo
					else if (!cur && nw) {
						// inserire prima del form / del primo PlpFilter__Group
						var target =
							document.querySelector("#CollectionFiltersForm") ||
							document.querySelector(".PlpSidebar__Filters");
						if (target) target.insertAdjacentHTML("beforebegin", nw.outerHTML);
					}
				});

				// Aggiorna ogni PlpFilter__Group per posizione dal response.
				// Shopify ricalcola conteggi, hidden/disabled, checked e is-active.
				var curGroups = document.querySelectorAll(".PlpFilter__Group");
				var newGroups = doc.querySelectorAll(".PlpFilter__Group");
				newGroups.forEach(function (ng, i) {
					if (curGroups[i]) {
						curGroups[i].outerHTML = ng.outerHTML;
					}
				});

				// Nasconde i gruppi con ≤ 1 opzione rimasta dopo il filtraggio
				updateGroupVisibility();

				url.searchParams.delete("section_id");
				history.pushState(
					{},
					"",
					url.pathname + (url.search ? url.search : ""),
				);
			})
			.catch(function (err) {
				console.error("[PLP Filter] fetch error:", err);
			});
	}

	// ── Costruisce URL dai sidebar checkboxes (data-param/data-value) ───────
	function buildSidebarParams() {
		var params = new URLSearchParams(window.location.search);
		Array.from(params.keys()).forEach(function (k) {
			if (k.startsWith("filter.")) params.delete(k);
		});
		// Filtri non-tag (colore, taglia…): usano data-param/data-value
		document
			.querySelectorAll(".PlpSidebar__FilterInput:checked")
			.forEach(function (cb) {
				params.append(cb.dataset.param, cb.dataset.value);
			});
		// Filtri tag (filter.p.tag): nel drawer usano name/value senza classe
		// PlpSidebar__FilterInput — vanno letti separatamente per non perderli
		// quando si cambia un filtro non-tag.
		var form = getFilterForm();
		if (form) {
			form
				.querySelectorAll("input[type='checkbox'][name]:checked")
				.forEach(function (cb) {
					params.append(cb.name, cb.value);
				});
		}
		return params;
	}

	// ── Drawer form: change su qualsiasi input ───────────────────────────────
	var filterForm = getFilterForm();
	if (filterForm) {
		filterForm.addEventListener("change", function () {
			var currentFilterForm = getFilterForm();
			// FormData cattura solo gli input con attributo "name" (tag filter).
			// I PlpSidebar__FilterInput (colore, taglia…) non hanno "name": vanno
			// aggiunti manualmente, altrimenti vengono persi al cambio di un tag filter.
			var params = new URLSearchParams(new FormData(currentFilterForm));
			currentFilterForm
				.querySelectorAll(".PlpSidebar__FilterInput:checked")
				.forEach(function (cb) {
					params.append(cb.dataset.param, cb.dataset.value);
				});
			var currentSort = new URLSearchParams(window.location.search).get(
				"sort_by",
			);
			if (currentSort) params.set("sort_by", currentSort);
			fetchSection(currentFilterForm.action + "?" + params.toString());
		});
	}

	// ── Aggiornamento immediato is-active su qualsiasi checkbox ─────────────
	// Viene eseguito in modo sincrono al click, senza aspettare fetchSection,
	// per tutti i filtri (tag e non-tag, drawer e sidebar).
	document.addEventListener("change", function (e) {
		if (e.target.type === "checkbox") {
			var label = e.target.closest(
				".PlpFilter__Value, .PlpFilter__Value--checkbox",
			);
			if (label) label.classList.toggle("is-active", e.target.checked);
		}
	});

	// ── Sidebar checkboxes ───────────────────────────────────────────────────
	document.addEventListener("change", function (e) {
		if (e.target.matches(".PlpSidebar__FilterInput")) {
			var params = buildSidebarParams();
			fetchSection(window.location.pathname + "?" + params.toString());
		}
	});

	// ── Sort popover + Reset filtri ──────────────────────────────────────────
	document.addEventListener("click", function (e) {
		// Cancella filtri per gruppo
		var clearGroupBtn = e.target.closest(".PlpFilter__GroupClear");
		if (clearGroupBtn) {
			e.preventDefault();
			e.stopPropagation(); // evita toggle del <details>
			var param = clearGroupBtn.dataset.filterClearParam;
			var values = clearGroupBtn.dataset.filterClearValues; // solo per filter.p.tag
			var params = new URLSearchParams(window.location.search);
			if (values) {
				// tag group: rimuovi solo i valori di questo gruppo, lascia gli altri
				var toRemove = values.split(",");
				var existing = params.getAll(param);
				params.delete(param);
				existing.forEach(function (v) {
					if (toRemove.indexOf(v) === -1) params.append(param, v);
				});
			} else {
				params.delete(param);
			}
			fetchSection(window.location.pathname + "?" + params.toString());
			return;
		}

		// Sort
		var sortLink = e.target.closest("[data-sort-value]");
		if (sortLink) {
			e.preventDefault();
			var params = new URLSearchParams(window.location.search);
			params.set("sort_by", sortLink.dataset.sortValue);
			document.querySelectorAll("[data-sort-value]").forEach(function (el) {
				el.classList.toggle("is-active", el === sortLink);
			});
			fetchSection(window.location.pathname + "?" + params.toString());
			return;
		}

		// Reset
		if (e.target.matches('[data-action="reset-filters"]')) {
			var currentFilterForm = getFilterForm();
			if (currentFilterForm) currentFilterForm.reset();
			document
				.querySelectorAll(".PlpSidebar__FilterInput")
				.forEach(function (cb) {
					cb.checked = false;
				});
			document
				.querySelectorAll(
					".PlpFilter__Value.is-active, .PlpFilter__Value--checkbox.is-active",
				)
				.forEach(function (lbl) {
					lbl.classList.remove("is-active");
				});
			var resetParams = new URLSearchParams();
			var currentSort = new URLSearchParams(window.location.search).get(
				"sort_by",
			);
			if (currentSort) resetParams.set("sort_by", currentSort);
			var baseUrl = currentFilterForm
				? currentFilterForm.action
				: window.location.pathname;
			fetchSection(
				baseUrl + (resetParams.toString() ? "?" + resetParams.toString() : ""),
			);
			return;
		}

		// Paginazione
		var pageLink = e.target.closest("#bc-sf-filter-bottom-pagination a");
		if (pageLink) {
			e.preventDefault();
			fetchSection(pageLink.href);
		}

		var activeFilterLink = e.target.closest("[data-active-filter]");
		if (activeFilterLink) {
			e.preventDefault();
			var param = activeFilterLink.dataset.filterParam;
			var value = activeFilterLink.dataset.filterValue;

			if (param && value) {
				// Feedback visivo immediato: deseleziona checkbox e rimuove is-active
				// prima che la fetch completi.
				document
					.querySelectorAll(
						'.PlpSidebar__FilterInput[data-param="' +
							CSS.escape(param) +
							'"][data-value="' +
							CSS.escape(value) +
							'"]',
					)
					.forEach(function (cb) {
						cb.checked = false;
						var lbl = cb.closest(
							".PlpFilter__Value, .PlpFilter__Value--checkbox",
						);
						if (lbl) lbl.classList.remove("is-active");
					});

				var formCb = document.querySelector(
					'#CollectionFiltersForm input[name="' +
						CSS.escape(param) +
						'"][value="' +
						CSS.escape(value) +
						'"]',
				);
				if (formCb) {
					formCb.checked = false;
					var lbl = formCb.closest(
						".PlpFilter__Value, .PlpFilter__Value--checkbox",
					);
					if (lbl) lbl.classList.remove("is-active");
				}

				// Usa l'url_to_remove generato da Shopify: rimuove esattamente quel filtro.
				// fetchSection sincronizzerà lo stato di tutte le checkbox dal response.
				fetchSection(activeFilterLink.href);
			} else {
				var resetBtn = document.querySelector('[data-action="reset-filters"]');
				if (resetBtn) resetBtn.click();
				else fetchSection(activeFilterLink.href);
			}
			return;
		}
	});

	// ── Browser back/forward ─────────────────────────────────────────────────
	window.addEventListener("popstate", function () {
		fetchSection(window.location.href);
	});

	// ── Visibilità gruppi al caricamento iniziale ────────────────────────────
	updateGroupVisibility();

})();
